import { render, staticRenderFns } from "./history.vue?vue&type=template&id=512fe562&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=512fe562&prod&lang=css"
import style1 from "./history.vue?vue&type=style&index=1&id=512fe562&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512fe562",
  null
  
)

export default component.exports